<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  page: {
    title: "Penjadwalan",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = []; // select sortOrder
    // definisi kolom yang dipakai
    let columns = [
			{ width: "50px", label: "No", name: "-" },

			{ width: "auto", label: "Kode Tes", name: "kode_tes" },
			{ width: "auto", label: "Batch", name: "nama_batch" },
			{ width: "auto", label: "Tanggal Mulai", name: "waktu_mulai" },
			{ width: "auto", label: "Tanggal Selesai", name: "waktu_selesai" },

			{ width: "200px", label: "Aksi", name: "-" }
		];
    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Report Proctor Peserta - Detail Batch",
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,


      tableData: {
        columns: columns,
        sortKey: "kode_tes",
        sortOrders: sortOrders,
        loading: true,
        data: [],
        filter: {
          draw: 0,
          page: 1,
          per_page: 10,
          search: "",
          column: 'kode_tes',
          dir: 'asc',
          idjadwal: this.$route.query.idjadwal,
          idjadwal_batch: null,
          tanggal_mulai: "",
          tanggal_selesai: "",
        },
        pagination: {
          lastPage: "",
          currentPage: "",
          total: "",
          lastPageUrl: "",
          nextPageUrl: "",
          prevPageUrl: "",
          from: "",
          to: "",
          links: "",
        },
      },

      option_batch: [],
    };
  },
  mounted() {
    let self = this;
    // self.cekAksesMenu();
    self.getDataTable();
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
    this.filterBatch = _.debounce(this.searchBatch.bind(this), 500);
    this.searchBatch(true, "");
  },
  methods: {
		formatDate(date) {
			if (!date) return "-";
			const [datePart, timePart] = date.split(" ");
			const [year, month, day] = datePart.split("-");
			return `${day}-${month}-${year} ${timePart}`;
		},
    searchBatch(loading, search) {
      const authToken = localStorage.access_token;
      axios
        .get(
          process.env.VUE_APP_BACKEND_URL_VERSION +
            `referensi/search-batch?keyword=${search}&idjadwal=${this.tableData.filter.idjadwal}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.option_batch = response.data.data.referensi;

          loading(false);
        })
        .catch(() => {});
      console.log();
    },
    getDataTable(resetPage = true) {
      this.tableData.filter.page = resetPage ? 1 : this.tableData.filter.page;
      let self = this;
      self.tableData.loading = true;
      self.tableData.filter.draw++;

      var config = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "report-proctor-peserta/batch-jadwal-asesmen",
        params: self.tableData.filter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            self.tableData.data = response_data_fix.data;
            self.configPagination(response_data_fix);
            self.tableData.pagination.currentPage = response_data_fix.current_page;
            self.tableData.loading = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data_fix.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      this.tableData.pagination.lastPage = data.last_page;
      this.tableData.pagination.currentPage = data.current_page;
      this.tableData.pagination.total = data.total;
      this.tableData.pagination.lastPageUrl = data.last_page_url;
      this.tableData.pagination.nextPageUrl = data.next_page_url;
      this.tableData.pagination.prevPageUrl = data.prev_page_url;
      this.tableData.pagination.from = data.from;
      this.tableData.pagination.to = data.to;
      this.tableData.pagination.links = data.links;
    },
    sortBy(key) {
      let self = this;
      self.tableData.sortKey = key;
      self.tableData.sortOrders[key] = self.tableData.sortOrders[key] * -1;
      self.tableData.filter.column = key;
      self.tableData.filter.dir = self.tableData.sortOrders[key] === 1 ? "asc" : "desc";
      self.getDataTable();
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");      
      this.tableData.filter.page = link.get("page");
      this.getDataTable(false);
    },
    onChangeJadwal() {
      this.tableData.idbatch = null;
      this.tableData.idjadwal = this.selected_id_jadwal?.idjadwal;
      this.searchBatch(true, "");
    },
    onChangeBatch() {
      this.tableData.filter.idjadwal_batch = this.selected_batch?.idjadwal_batch;
    },
    backButton(){
      this.$router.push({
        name: "report-proctor-peserta",
      });
    },
    detail(row) {
      this.$router.push({
        name: "report-proctor-peserta-detail-list-peserta",
        query: { idjadwal: row.idjadwal, idjadwal_batch: row.idjadwal_batch },
      });
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <!-- bagian navigasi halaman -->
              <div class="col-md-12 d-flex justify-content-between align-item-center">
                <div>
                  <b-button
                    size="sm"
                    variant="danger"
                    class="fw-bold"
                    @click="backButton"
                  >
                    <i class="fa fa-arrow-left me-1"></i>
                    Kembali
                  </b-button>
                </div>
              </div>
              <!-- --------------------- -->

              <div class="col-md-12">
                <hr />
                <div class="row">
                  <div
                    class="form-group col-md-4 mb-2"
                    v-if="tableData.filter.idjadwal"
                  >
                    <label for="statusTable">Batch</label>
                    <v-select
                      :options="option_batch"
                      v-model="selected_batch"
                      label="nama_batch"
                      placeholder="Pilih Batch"
                      @search="onSearchBatch"
                      v-on:update:modelValue="
                        onChangeBatch();
                        getDataTable();
                      "
                    >
                    </v-select>
                  </div>
                  <div class="form-group col-md-2 mb-2">
                    <label for="filterTanggalMulai">Tanggal Mulai</label>
                    <input
                      type="date"
                      class="form-control"
                      id="filterTanggalMulai"
                      v-model="tableData.filter.tanggal_mulai"
                      @change="getDataTable()"
                    />
                  </div>
                  <div class="form-group col-md-2 mb-2">
                    <label for="filterTanggalSelesai">Tanggal Selesai</label>
                    <input
                      type="date"
                      class="form-control"
                      id="filterTanggalSelesai"
                      v-model="tableData.filter.tanggal_selesai"
                      @change="getDataTable()"
                    />
                  </div>
                </div>
                <hr />
              </div>
              <div class="col-md-12 mb-2">
                <div class="row">
                  <div class="col-md-12">
                    <table>
                      <tr>
                        <td>Show</td>
                        <td>
                          <select
                            class="form-control form-control-sm"
                            id="showpaginatetable"
                            style="width: 100%"
                            v-model="tableData.per_page"
                            @change="
                              tableData.page = 1;
                              getDataTable();
                            "
                          >
                            <option value="10" selected>10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                          </select>
                        </td>
                        <td>Entries</td>
                      </tr>
                    </table>
                  </div>
                  <!-- <div class="col-md-5">&nbsp;</div> -->
                  <!-- <div class="col-md-3">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      id="searchTable"
                      placeholder="Cari Data ..."
                      v-model="tableData.search"
                      @input="getDataTable()"
                    />
                  </div> -->
                </div>
              </div>
              <datatable
                :columns="tableData.columns"
                :sortKey="tableData.sortKey"
                :sortOrders="tableData.sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="tableData.loading">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="!tableData.data || tableData.data.length === 0" class="text-center">
                    <td class="text-center" colspan="99">
                      Data Tidak Tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row_data, key_data) in tableData.data"
                    :key="row_data.idjadwal_peserta"
                  >
                    <td class="text-center">
                      {{ (tableData.pagination.currentPage - 1) * (tableData.filter.per_page || 10) + key_data + 1 }}
                    </td>
                    <td class="text-center">{{ row_data.kode_tes }}</td>
										<td class="text-center">{{ row_data.nama_batch }}</td>
										<td class="text-center ">
                      <span class="text-nowrap">{{ formatDate(row_data.waktu_mulai) }}</span>
                    </td>
                    <td class="text-center ">
                      <span class="text-nowrap">{{ formatDate(row_data.waktu_selesai) }}</span>
                    </td>
                    <td class="text-center">
                      <div class="btn-group btn-group-sm">
                        <button
                          class="btn btn-info btn-sm"
                          @click="detail(row_data)"
                        >
                          <i class="fa fa-external-link-alt"></i> Detail
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </datatable>
            </div>
            <pagination :pagination="tableData.pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
